// React Modules
import React, { useContext } from 'react'
import { Button } from '@insight/toolkit-react'
import { t } from '@insight/toolkit-utils'
import { SearchContext } from '../../context/SearchContext'
import { CONTENTMAP, IN_STOCK_STATUS_FIELD } from '../../constants'
import { noOp } from '../../shared/utils'

export const SearchControlsBottom = ({
  clearFilters,
  setRange,
  setStockFilter = noOp,
}) => {
  const { tabType, originalFilters: origFilters, setFilter: setFilterFromContext, contentSelectedFilters, clearContentFilters } = useContext(SearchContext);
  const isSolutionsTab = tabType === CONTENTMAP.solutionsAndServices.id;
  const originalFilters = isSolutionsTab ? contentSelectedFilters : origFilters;

  const handleFilter = (filter) => {
    const { key, label, type, val, _deselect } = filter
    switch (type) {
      case 'rangeFacet':
        setRange({ group: key, ...{ key, label, type, val } })
        break
      case 'selectedFacet':
        // Prefer the controller-provided deselect callback (present on Coveo
        // breadcrumb entries) so content facets can also be cleared from the chips UI.
        if (_deselect) {
          _deselect()
        } else {
          setFilterFromContext({ group: key, val })
        }
        break
      case 'instockOnly':
        setStockFilter()
        break
    }
  }

  // originalFilters is built directly from Coveo breadcrumbs, so every entry here
  // (including the IN_STOCK_STATUS_FIELD facet when its value is 'false', i.e. an
  // out-of-stock-only constraint) represents a real, actively-selected facet and
  // must always render a clearable chip — never silently hidden.
  const visibleFilters = originalFilters ? Array.from(originalFilters) : []

  const renderFilters = () => {
    if (!visibleFilters.length) {
      return null
    }

    return visibleFilters.map(([key, filter]) => {
      const filterLabel = filter.key === IN_STOCK_STATUS_FIELD
        ? (filter.val === 'false' ? t('Out of stock only') : t('In stock only'))
        : (filter.label || filter.val)
      return (
        <div key={key} className="c-search-controls__bottom__filter u-text-bold">
          <div>{filterLabel}</div>
          <Button
            className="c-search-controls__bottom__filter__close"
            color="none"
            onClick={() => handleFilter(filter)}
            aria-label={t('Clear')}
            icon="close"
          />
        </div>
      )
    })
  }
  if (!visibleFilters.length) {
    return null
  }
  return (
    <>
      <section className="c-search-controls__bottom">
        <div className="c-search-controls__bottom__filters">
          <div className="u-text-bold c-search-controls__bottom__filter-title">
            {t('Filters:')}
          </div>
          {renderFilters()}
          {visibleFilters.length > 1 ? (
            <Button
              className="c-search-controls__bottom__clear-all"
              color="inline-link"
              onClick={() => isSolutionsTab ? clearContentFilters?.() : clearFilters()}
            >
              {t('Clear all')}
            </Button>
          ) : null}
        </div>
      </section>
    </>
  )
}
